import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { chatList } from 'modules/actions/chat';
import { imageData } from 'components/molecules/MessageTemplateSet/BotMessage/imageData';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import IconButton from 'components/atoms/Button/IconButton';
import {
  SimpleMessage,
  TextMessage,
  ButtonMessage,
  ImageButtonMessage,
  MediaMessage,
  ImageMessage,
  ImageCarousel,
  CardDefault,
  BigCard,
  ListBtn,
  SmallCard,
  IntroButton,
  ListBtnTitle,
  CardExtend,
  ListBtnCarousel,
  ImageBtnCarousel,
} from 'components/molecules/MessageTemplateSet/Templates/index';
import { isActiveSearchCenterModal, isActiveSearchJichungModal, isActiveSupportSystemModal, isActiveFeedbackModal, loading } from 'modules/actions/statusMenu';
import { setMessageId } from 'modules/actions/quality';
import { setMilType, setMilName } from 'modules/actions/supportSystem';
import { setSido } from 'modules/actions/searchAddr';
import axios from 'axios';
/**
 * BotMessage
 */
const BotMessage = ({ boxStyle, item, responseType, index }) => {
  const dispatch = useDispatch();
  const isQualitySend = useSelector(state => state.chatList.data[index].isQualitySend);
  // 글로벌 파라미터 TEST
  const onSendMessage = (inStr, inType, inLabel) => {
    if (inType !== 'url') {
      if (inStr.startsWith('support_system')) {
        openSupportSystemModal(inStr, inLabel);
      } else if (inStr === 'search_jichung') {
        openSearchJichungModal();
      } else if (inStr === 'search_center') {
        openSearchCenterModal();
      } else if (inStr.startsWith('jobLink')){
        const job = inStr.split(',');
        // window.open("","parent");
        window.opener.postMessage({link: job[0], type: job[1], idx:job[2]}, '*');
      } else {
        const loginYN = sessionStorage.getItem('mbrId') ? 'true' : 'false';
        const paramSet = {
          inType: inType || 'query',
          inStr,
          inLabel,
          parameters: { login: loginYN, mbr_id: sessionStorage.getItem('mbrId') || ''}
        };
        dispatch(chatList(paramSet));
      }
    } else {
      window.open(inStr.replace(/&amp;/g, '&'));
      // 로그인 또는 회원가입 페이지로 갈 때 챗봇 창 닫기
      if(inStr === 'https://www.vnet.go.kr/gud/GudMbrLgn.do' || inStr === 'https://www.vnet.go.kr/gud/GudMbrJn.do') window.close();
    }
  };
  const makeKeyVal = (id, idx) => `bot_${id}_${idx}`;

  const setSimpleItem = (message, idx) => {
    if (message) {
      return <SimpleMessage idx={idx} key={makeKeyVal('simple', idx)} item={message} boxStyle={boxStyle} />;
    }
    return false;
  };
  const setTemplateItem = (tempItem, idx) => {
    // console.log("id::::::::::::", id);
    const { id, items } = tempItem;
    // items 없을 경우 return false
    if(!items) {
      return false;
    }
    const key = makeKeyVal(id, idx);
    if (id === 'textbox') {
      return <TextMessage key={key} item={tempItem} boxStyle={boxStyle} />;
    }
    if (id === 'media') {
      return <MediaMessage key={key} item={tempItem} />;
    }
    if (id === 'quick_btn') {
      // return <ButtonMessage key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: 120, margin: 1, height: '30px', fontSize: boxStyle.fontSize }} />;
      return <ButtonMessage key={key} quickId={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{fontSize: boxStyle.fontSize }} />;
    }
    if (id === 'image') {
      return <ImageMessage key={key} item={tempItem} />;
    }
    if (id === 'image_btn') {
      return <ImageButtonMessage key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: '109px', height: '109px', fontSize: boxStyle.fontSize }}  />;
    }
    if (id === 'list_btn') {
      return <ListBtn key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }
    if (id === 'list_btn_title') {
      return <ListBtnTitle key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }
    if (id === 'intro_btn') {
      return <IntroButton key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }
    if (id === 'image_carousel') {
      return <ImageCarousel key={key} item={tempItem} boxStyle={{ width: 345, margin: 11, height: '410px', fontSize: boxStyle.fontSize }} />;
    }
    if (id === 'big_card') {
      return <BigCard key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: 345, margin: 11, height: '410px', fontSize: boxStyle.fontSize }} />;
    }
    if (id === 'small_card') {
      return <SmallCard key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: 168, margin: 4.5, height: '230px', fontSize: boxStyle.fontSize }} />;
    }
    if (id === 'card_extend') {
      return <CardExtend key={key} item={tempItem} boxStyle={{ width: 345, margin: 11, height: '400px', fontSize: boxStyle.fontSize }} />;
    }
    if (id === 'list_btn_carousel') {
      return <ListBtnCarousel key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: 345, margin: 11, height: '230px', fontSize: boxStyle.fontSize }} />;
    }
    if (id === 'image_btn_carousel') {
      return <ImageBtnCarousel key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: 150, margin: 4.5, height: '120px', fontSize: boxStyle.fontSize }} />;
    }

    return false;
  };
  // console.log('item:', item);

  const openFeedbackModal = () => {
    dispatch(setMessageId(item.id));
    dispatch(isActiveFeedbackModal());
  };

  const openSupportSystemModal = (inStr, inLabel) => {
    dispatch(setMilType(inStr));
    dispatch(setMilName(inLabel));
    dispatch(isActiveSupportSystemModal());
  };

  const openSearchJichungModal = async () => {
    dispatch(setSido(await searchSido('jichung')));
    dispatch(isActiveSearchJichungModal());
  };

  const openSearchCenterModal = async () => {
    dispatch(setSido(await searchSido('center')));
    dispatch(isActiveSearchCenterModal());
  };

  const searchSido = async (indexNm) => {
    let res = [];
    // 주소 api
    await axios.post('/chat/addressAggs', {
      index: indexNm,
      sido: '',
    }).then(response => {
      res = response.data.aggs;
    }).catch(error => {
      console.log(error);
    })
    return(res);
  }

  const [msgBtm, setMsgBtm] = useState(345);
  const chatMsgDiv = useRef();
  let msgBtmStyle = {};
  let cardUseState;
  if (item?.templateMessages) {
    cardUseState = item?.templateMessages.find(ele => {
      if (ele.id.includes('_card') || ele.id.includes('_btn') || ele.id.includes('_carousel')) {  // 보훈부에서 새로 추가한 id 패턴 : '_carousel'
        return true;
      }
      return false;
    });
  }
  if (cardUseState) {
    msgBtmStyle = { width: '100%', maxWidth: 'fit-content' };
  } else {
    msgBtmStyle = { display: 'table' };
  }

  useLayoutEffect(() => {
    // console.log('chatMsgDiv?.current?.clientWidth : ', chatMsgDiv?.current?.clientWidth);
    setMsgBtm(chatMsgDiv?.current?.clientWidth);
    function handleResize(a) {
      setMsgBtm(chatMsgDiv?.current?.clientWidth);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });
  return (
    <div className="bot_message_div">
      <div className="_chat_name">
        <div className="_img"><img className="profile" src="/chat/images/icon_profile.png" alt="로고" /></div>
        <span>보보</span>
      </div>
      <div className="_chat_message">
        {item.response_status === 'loading' ? (
          <div className="_chat_message_set">
            <div className="_text_div">
              <div className="_message">
                <div className="loading">
                  <div className="ldio-er80fzh2vjb">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              </div>
            </div>
            {item.createAt && (
              <div className="_chat_message_bottom">
                <div className="_chat_message_bottom_div">
                  <div className="_chat_time">{item.createAt}</div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            <div className="_chat_message_set" ref={chatMsgDiv} style={msgBtmStyle}>
              {' '}
              {item?.messages?.map((message, idx) => {
                return setSimpleItem(message, idx);
              })}
              {/* items Template */}
              {item?.templateMessages?.map((tempItem, idx) => {
                return setTemplateItem(tempItem, idx);
              })}
            </div>
            {item.createAt && (
              <div className="_chat_message_bottom">
                {/* <div className="_chat_message_bottom_div" style={{ width: msgBtm + 'px' }}> */}
                <div className="_chat_message_bottom_div">
                  <div className="_chat_time">{item.createAt}</div>
                  {item.response_status !== 'welcome' && item.response_status !== 'satisfy' && !isQualitySend ? (
                    <button type="button" className="_chat_opinion" onClick={() => openFeedbackModal()}>
                      <div className="_at_icon_button_div" style={{ width: "15px", height: "13px", float: "left", fontSize: "13px" , color: '#767676'}}>
                        <div aria-label="" title="" className="_button_div">
                          <div className="_icon">
                            <i className="ri-mail-send-line" />
                          </div>
                        </div>
                      </div>
                      의견남기기
                    </button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
BotMessage.propTypes = {
  boxStyle: PropTypes.object,
  responseType: PropTypes.string,
  item: PropTypes.object,
  index: PropTypes.number,
};
BotMessage.defaultProps = {
  boxStyle: {},
  item: {
    messageId: '',
    emotion: '',
    createAt: '2021.01.01 00:00',
    messages: [],
    templateMessages: [],
  },
  responseType: 'query',
  index: 0,
};

export default BotMessage;
